import { render } from "./DistributorInvoiceView.vue?vue&type=template&id=4e406be9"
import script from "./DistributorInvoiceView.vue?vue&type=script&lang=js"
export * from "./DistributorInvoiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__